import { locale } from "primereact/api";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useLocation } from "react-router-dom";

const AuthLayout = () => {
    const [lang, setLang] = useState<any>();
    const { t, i18n } = useTranslation();
    const location = useLocation();

    const countries = [
        { name: 'EN', code: 'GB', lang: "en" },
        { name: 'TR', code: 'TR', lang: 'tr' },
    ];

    useEffect(() => {
        localStorage.getItem("i18nextLng") === "en" ? setLang({ name: 'EN', code: 'GB', lang: "en" })
            : setLang({ name: 'TR', code: 'TR', lang: 'tr' })
    }, []);

    useEffect(() => {
        if (lang) {
            i18n.changeLanguage(lang.lang)
            locale(lang.lang);
        }
    }, [lang]);

    const countryOptionTemplate = (option: any) => {
        return (
            <div className="flex align-items-center">
                <img alt={option.name} src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`} className={`mr-2 flag flag-${option.code.toLowerCase()}`} style={{ width: '18px' }} />
                <div>{option.name}</div>
            </div>
        );
    };

    const selectedCountryTemplate = (option: any, props: any) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                    <img alt={option.name} src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                        className={`mr-2 flag flag-${option.code.toLowerCase()}`} style={{ width: '18px' }} />
                    <div>{option.name}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    return (
        <div style={{ background: "linear-gradient(to bottom, #F5F5F5, rgba(45, 57, 103, 0.2))" }}>
            <div className='flex justify-content-between align-items-center px-3'>

                <div style={{width:"65%",height:"97vh"}}>
                    <img
                        src="/signin-image.png"
                        alt='Signing Image'
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "18px"
                        }}
                    />
                </div>


                <div className='w-full flex flex-column justify-content-center align-items-center'
                    style={{ minHeight: '100vh', paddingLeft: '1rem', paddingRight: '1rem' }}>
                    <div className={`flex flex-column justify-content-center ${location.pathname === '/' ? 'align-items-start' : 'align-items-center'} w-8`}>
                        <div className='flex w-full justify-content-end my-4'>
                            <Dropdown value={lang} onChange={(e) => setLang(e.value)} options={countries} optionLabel="name"
                                valueTemplate={selectedCountryTemplate} itemTemplate={countryOptionTemplate}
                                className='w-5rem' style={{ border: '1.5px solid #2D3967', backgroundColor: "#F5F5F5" }} />
                        </div>
                        <Outlet context={{ t }} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AuthLayout;